import { Query } from '@cubejs-client/core';
import { CardGraphBase } from '../CardGraphBase';

export default class PaymentVolumeCard extends CardGraphBase {
  graphName() { return ''; }

  graphSubtitle() { return 'Total Volume'; }

  processValue(value) {
    return `$${super.processValue(Number(value).toFixed(0))}`;
  }

  query(): Query {
    return {
      measures: [
        'FctGeneral.totalCollectedPaymentsInDollars',
      ],
      timeDimensions: [
        {
          dimension: 'FctGeneral.dateDay',
          dateRange: this.props?.timePeriod,
        },
      ],
      order: {},
      filters: [
        {
          dimension: 'FctGeneral.organisationId',
          operator: 'equals',
          values: [
            this.props.organisationId,
          ],
        },
        // {
        //   dimension: 'FctGeneral.competitionId',
        //   operator: 'equals',
        //   values: [
        //     this.props.competitionId,
        //   ],
        // },
      ],
    };
  }
}
// {
//     "measures": [
//         "Payments.dollarAmount"
//     ],
//     "timeDimensions": [
//         {
//             "dimension": "Payments.createdAt",
//             "dateRange": this.props.timePeriod
//         }
//     ],
//     "order": {},
//     "filters": []
// }
